module.exports = __webpack_public_path__ + "img/qu_gh.428abff.jpg";